import React from 'react';

const ContactForm = () => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-lg-6 col-md-6">
                    <div className="contact_us">
                        <div className="section_header">
                            <h2 className="section_title">Keep in Touch</h2>
                            <h6 className="section_sub_title">
                                Send us mail if you have anything to suggest
                            </h6>
                        </div>
                        <form
                            className="contact_form"
                            action="contact.php"
                            method="post"
                        >
                            <div className="form-container">
                                <div className="form-group">
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-control"
                                        placeholder="Your Name*"
                                        required=""
                                    />
                                </div>
                                <div className="form-group">
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control"
                                        placeholder="Your Email Address*"
                                        required=""
                                    />
                                </div>
                                <div className="form-group">
                                    <textarea
                                        name="message"
                                        className="form-control"
                                        placeholder="Message Here*"
                                        required=""
                                    ></textarea>
                                </div>
                                <div className="form-group">
                                    <input
                                        className="button"
                                        type="submit"
                                        value="Send"
                                        name="submit"
                                    />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactForm;